import { render, staticRenderFns } from "./TechDataCenter.vue?vue&type=template&id=fdae4d8c&scoped=true&"
import script from "./TechDataCenter.vue?vue&type=script&lang=js&"
export * from "./TechDataCenter.vue?vue&type=script&lang=js&"
import style0 from "./TechDataCenter.vue?vue&type=style&index=0&id=fdae4d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdae4d8c",
  null
  
)

export default component.exports